import * as React from 'react';
import { Typography, Link } from '@mui/material';


export default function Copyright(props) {
  return (
    <Typography variant="body2"  color="grey.500" align="center" {...props}>
      {'Copyright © '}
      <Link color="inherit" href="https://trawlai.com/">
        Prevail Cybersecurity
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}